import { useEffect } from 'react';

/**
 * MetaTags Component
 * Dynamically updates Open Graph and Twitter Card meta tags for social sharing
 * 
 * Usage:
 * <MetaTags 
 *   title="My Outfit"
 *   description="Check out this amazing outfit"
 *   image="https://example.com/image.jpg"
 *   url="https://example.com/outfit/123"
 *   type="website"
 * />
 */
const MetaTags = ({ 
  title = 'Outsera - 3D Fashion Marketplace',
  description = 'Outfit + Era — Create, collect, and trade 3D digital fashion on Solana.',
  image = '/images/Chrome logo icon.png',
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = 'website',
  twitterCard = 'summary_large_image',
  siteName = 'Outsera'
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper function to update or create meta tags
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, property);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Update standard meta tags
    updateMetaTag('description', description, false);

    // Update Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', image);
    updateMetaTag('og:url', url);
    updateMetaTag('og:type', type);
    updateMetaTag('og:site_name', siteName);

    // Update Twitter Card tags
    updateMetaTag('twitter:card', twitterCard, false);
    updateMetaTag('twitter:title', title, false);
    updateMetaTag('twitter:description', description, false);
    updateMetaTag('twitter:image', image, false);
    updateMetaTag('twitter:site', '@OutseraIO', false);
    updateMetaTag('twitter:creator', '@OutseraIO', false);

    // Cleanup function (optional - keeps tags persistent across page changes)
    return () => {
      // We don't remove tags to prevent flickering
      // Tags will be updated by the next component that mounts
    };
  }, [title, description, image, url, type, twitterCard, siteName]);

  return null; // This component doesn't render anything
};

export default MetaTags;

